/**
 * Asked before a message goes into an old or unrelated thread: "Start a new
 * chat? This thread is about <title>". The attorney decides.
 */
import { MessageSquarePlus } from "lucide-react";
import type { FC } from "react";

import { Button } from "@/components/ui/button";

import type { ContinuityReason } from "../threadContinuity";

type Props = {
  title: string;
  reason: ContinuityReason;
  onNewChat: () => void;
  onSendHere: () => void;
};

export const ContinuityPrompt: FC<Props> = ({
  title,
  reason,
  onNewChat,
  onSendHere
}) => (
  <div
    className="flex flex-col gap-2 rounded-xl px-3 py-2.5 ring-1 ring-line-2"
    role="alertdialog"
    aria-label="Start a new chat?"
    data-testid="continuity-prompt"
    data-reason={reason}
  >
    <p className="text-base text-fg">
      Start a new chat?{" "}
      <span className="text-fg-3">
        This thread is about {title || "something else"}
        {reason === "stale" ? " and has been quiet for a while." : "."}
      </span>
    </p>
    <div className="flex gap-1.5">
      <Button
        size="xs"
        variant="tonal"
        onClick={onNewChat}
        data-testid="continuity-new-chat"
      >
        <MessageSquarePlus />
        New Chat
      </Button>
      <Button
        size="xs"
        variant="ghost"
        onClick={onSendHere}
        data-testid="continuity-send-here"
      >
        Send Here
      </Button>
    </div>
  </div>
);
